module.exports = __webpack_public_path__ + "static/UIOM-9cc1042395ec941610c57f5736806e79.png";